import i18n from '@app/plugins/i18n';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { PhoneListService } from '@pbx/services/PhoneListService';

class PhoneListModalService extends ModalService {
  constructor() {
    super(PhoneListService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('pbx.phone-list.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }
}

const instance = new PhoneListModalService();
export { instance as PhoneListModalService };
